<cm-ruler-workspace
    #rulerWorkspace
    [pixelsPerCm]="canvas.$pixelsPerCm()"
    [workspaceZoom]="canvas.$viewZoomLevel()"
    [workspaceOffsetPx]="canvas.$viewOffsetPx()"
    [cursorPositionPx]="canvas.$cursorPositionPx()"
>
    <cm-canvas #canvas [pixelsPerCm]="$physicalInfo().pixelsPerCm"></cm-canvas>
</cm-ruler-workspace>
<ng-content></ng-content>
@if ($showSpinner()) {
    <div class="spinner-container">
        <div class="spinner"></div>
    </div>
}
@if ($message()) {
    <div class="message_container">
        <div class="message">
            {{ $message() }}
        </div>
    </div>
}
